/* Leaflet marker fix — default icons are missing after webpack bundling.
 * This ensures pins render in all route pages (map view requirement).
 */
import L from "leaflet";
import iconRetina from "leaflet/dist/images/marker-icon-2x.png";
import iconPng from "leaflet/dist/images/marker-icon.png";
import shadowPng from "leaflet/dist/images/marker-shadow.png";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: iconRetina,
  iconUrl: iconPng,
  shadowUrl: shadowPng,
});

const mk = (color) => new L.DivIcon({
  className: "",
  html: `<div style="width:18px;height:18px;border-radius:50%;background:${color};border:2px solid #fff;box-shadow:0 1px 3px rgba(0,0,0,0.4);"></div>`,
  iconSize: [18, 18], iconAnchor: [9, 9], popupAnchor: [0, -9],
});

const seqIcon = (seq, color = "#2D5A27") => new L.DivIcon({
  className: "",
  html: `<div style="width:24px;height:24px;border-radius:50%;background:${color};color:#fff;border:2px solid #fff;box-shadow:0 1px 3px rgba(0,0,0,0.4);display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;font-family:'JetBrains Mono',monospace;">${seq}</div>`,
  iconSize: [24, 24], iconAnchor: [12, 12], popupAnchor: [0, -12],
});

export const ICONS = {
  customer: mk("#8A8780"),
  selected: mk("#2D5A27"),
  start: mk("#0D47A1"),
  end: mk("#C25D38"),
  skipped: mk("#C25D38"),
  completed: mk("#2D5A27"),
  seq: seqIcon,
};
